import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ApplicationsState } from '@/store/applications/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'
import vacations from './vacations'
import booths from './booths'
import workOvertime from './workOvertime'
import spir from './spir'
import evaluationInquiries from './evaluationInquiries'

const Applications: Module<ApplicationsState, RootState> = {
  state: (): ApplicationsState => ({
    applications: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
  modules: {
    vacations,
    booths,
    workOvertime,
    spir,
    evaluationInquiries,
  },
};

export default Applications;
